import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { getLinksDate } from "../Pages/constants";

const obtenerLinks = (responseData) => {
  if (Array.isArray(responseData)) {
    return responseData;
  }

  if (Array.isArray(responseData?.data)) {
    return responseData.data;
  }

  if (Array.isArray(responseData?.links)) {
    return responseData.links;
  }

  return [];
};

const formatearFechaApi = (fecha) => {
  const year = fecha.getFullYear();
  const month = String(fecha.getMonth() + 1).padStart(2, "0");
  const day = String(fecha.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatearFechaVisible = (fecha) =>
  fecha.toLocaleDateString("es-MX", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const ZoomCalendarPanel = () => {
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());
  const [links, setLinks] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");

  const consultarFecha = useCallback(async (fecha) => {
    setCargando(true);
    setError("");
    setLinks([]);

    try {
      const response = await axios.get(getLinksDate, {
        params: { fecha: formatearFechaApi(fecha) },
      });
      setLinks(obtenerLinks(response.data));
    } catch (requestError) {
      if (requestError.response?.status === 404) {
        setLinks([]);
        return;
      }

      console.error("Error al obtener enlaces de Zoom por fecha:", requestError);
      setError("No fue posible consultar las reuniones de esta fecha.");
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    consultarFecha(fechaSeleccionada);
  }, [consultarFecha, fechaSeleccionada]);

  const seleccionarFecha = (fecha) => {
    setFechaSeleccionada(fecha);
  };

  return (
    <div className="zoom-calendar-panel">
      <div className="zoom-calendar-picker">
        <Calendar
          onClickDay={seleccionarFecha}
          value={fechaSeleccionada}
        />
      </div>

      <section className="zoom-calendar-results" aria-live="polite">
        <div className="zoom-calendar-results-header">
          <div>
            <span className="zoom-calendar-eyebrow">Reuniones programadas</span>
            <h2>{formatearFechaVisible(fechaSeleccionada)}</h2>
            <p>Selecciona cualquier día del calendario para consultar sus ligas de Zoom.</p>
          </div>
          {!cargando && !error && (
            <span className="zoom-calendar-count">
              {links.length} {links.length === 1 ? "reunión" : "reuniones"}
            </span>
          )}
        </div>

        {cargando && (
          <div className="zoom-calendar-state" role="status">
            <span className="zoom-calendar-spinner" aria-hidden="true" />
            <strong>Consultando reuniones...</strong>
          </div>
        )}

        {!cargando && error && (
          <div className="zoom-calendar-state zoom-calendar-state-error" role="alert">
            <strong>No se pudieron cargar las reuniones</strong>
            <p>{error}</p>
            <button type="button" onClick={() => consultarFecha(fechaSeleccionada)}>
              Intentar nuevamente
            </button>
          </div>
        )}

        {!cargando && !error && links.length === 0 && (
          <div className="zoom-calendar-state">
            <strong>No hay reuniones programadas</strong>
            <p>No existen ligas de Zoom registradas para esta fecha.</p>
          </div>
        )}

        {!cargando && !error && links.length > 0 && (
          <div className="zoom-calendar-links">
            {links.map((link, index) => (
              <article
                className="zoom-calendar-link-card"
                key={link.id_url || `${link.matricula_clase}-${link.hora}-${index}`}
              >
                <div className="zoom-calendar-link-info">
                  <span>Curso</span>
                  <strong>{link.nombre_clase || link.matricula_clase || "Curso sin identificar"}</strong>
                  {link.nombre_clase && link.matricula_clase && (
                    <small>{link.matricula_clase}</small>
                  )}
                </div>
                <div className="zoom-calendar-link-info">
                  <span>Hora</span>
                  <strong>{link.hora || "Sin hora"}</strong>
                </div>
                {link.url ? (
                  <a
                    className="zoom-calendar-open"
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Abrir Zoom
                  </a>
                ) : (
                  <span className="zoom-calendar-open zoom-calendar-open-disabled">
                    Sin enlace
                  </span>
                )}
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default ZoomCalendarPanel;
